/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TotalTivViewResponseDto
 */
export interface TotalTivViewResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TotalTivViewResponseDto
     */
    totalTiv: string;
    /**
     * 
     * @type {string}
     * @memberof TotalTivViewResponseDto
     */
    submissionId: string;
}

/**
 * Check if a given object implements the TotalTivViewResponseDto interface.
 */
export function instanceOfTotalTivViewResponseDto(value: object): value is TotalTivViewResponseDto {
    if (!('totalTiv' in value) || value['totalTiv'] === undefined) return false;
    if (!('submissionId' in value) || value['submissionId'] === undefined) return false;
    return true;
}

export function TotalTivViewResponseDtoFromJSON(json: any): TotalTivViewResponseDto {
    return TotalTivViewResponseDtoFromJSONTyped(json, false);
}

export function TotalTivViewResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TotalTivViewResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalTiv': json['totalTiv'],
        'submissionId': json['submissionId'],
    };
}

export function TotalTivViewResponseDtoToJSON(json: any): TotalTivViewResponseDto {
    return TotalTivViewResponseDtoToJSONTyped(json, false);
}

export function TotalTivViewResponseDtoToJSONTyped(value?: TotalTivViewResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalTiv': value['totalTiv'],
        'submissionId': value['submissionId'],
    };
}

